import type { DotNestedKeys } from "@/types/common.types";

// API Endpoints
export const API_ENDPOINTS = {
  core: import.meta.env.VITE_API_CORE_URL!,
  base: import.meta.env.VITE_API_BASE_URL!,
  ws: import.meta.env.VITE_WS_BASE_URL!,
  cexws: import.meta.env.VITE_WS_CEX_BASE_URL!,
  cexapi: import.meta.env.VITE_API_CEX_BASE_URL!,
  fe: import.meta.env.VITE_FE_BASE_URL!,
  proxy: import.meta.env.VITE_PROXY_API_BASE_URL!,
  trade: import.meta.env.VITE_TRADE_URL!,
};

export const ROUTES_CONFIG = {
  home: {
    path: "/",
    open: true,
  },
  login: {
    path: "/login",
    open: true,
  },

  logout: {
    path: "/logout",
    open: true,
  },
  signup: {
    path: "/signup",
    open: true,
  },
  dashboard: {
    path: "/dashboard",
    open: false,
  },
  marketplace: {
    path: "/marketplace",
    open: false,
  },
  orders: {
    path: "/orders",
    open: false,
  },
  ordersHistory: {
    path: "/order-history",
    open: false,
  },
  history: {
    path: "/history",
    open: false,
  },
  settings: {
    path: "/settings",
    open: false,
  },
  security: {
    path: "/security",
    open: false,
  },
  identification: {
    path: "/identification",
    open: false,
  },
  profile: {
    path: "/profile",
    open: false,
  },
  wallet: {
    path: "/wallet",
    open: false,
  },
  assets: {
    path: "/assets",
    open: false,
  },
  rewards: {
    path: "/rewards",
    open: false,
  },
  referrals: {
    path: "/referrals",
    open: false,
  },
  spot: {
    path: "/spot",
    open: false,
  },
  margin: {
    path: "/margin",
    open: false,
  },
  market: {
    path: "/market",
    open: true,
  },
  forgotPassword: {
    path: "/forgot-password",
    open: true,
  },
  resetPassword: {
    path: "/reset-password",
    open: true,
  },
  termsOfUse: {
    path: "/terms-of-use",
    open: true,
  },
  ex: {
    btcUsdt: {
      path: `${API_ENDPOINTS.trade}BTC-USDT`,
      open: true,
    },
    ethUsdt: {
      path: `${API_ENDPOINTS.trade}ETH-USDT`,
      open: true,
    },
    ltcUsdt: {
      path: `${API_ENDPOINTS.trade}LTC-USDT`,
      open: true,
    },
    solUsdt: {
      path: `${API_ENDPOINTS.trade}SOL-USDT`,
      open: true,
    },
  }
};

const destructRoutesRecursively = (
  obj: typeof ROUTES_CONFIG,
  parentKey = "",
  isOpen: boolean | null = null
): Record<string, string> => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;

    if (typeof value === "object" && "path" in value) {
      // Check open flag against isOpen
      if (
        isOpen === null ||                // include all
        (isOpen === true && value.open) || // include only open
        (isOpen === false && !value.open)  // include only closed
      ) {
        acc[newKey] = `${import.meta.env.VITE_FE_BASE_URL || ""}${value.path}`;
      }
    } else if (typeof value === "object") {
      // @ts-ignore
      Object.assign(acc, destructRoutesRecursively(value, newKey, isOpen));
    }
    return acc;
  }, {} as Record<string, string>);
};

type RoutePaths = DotNestedKeys<typeof ROUTES_CONFIG>;

export const ROUTES = destructRoutesRecursively(ROUTES_CONFIG) as Record<RoutePaths, string>;

export const OPEN_ROUTES = destructRoutesRecursively(ROUTES_CONFIG, "", true);

export const CLOSED_ROUTES = destructRoutesRecursively(ROUTES_CONFIG, "", false);